// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.organization.main],
        guard: getPermissionsGuard([{ resource: 'portal.organization', scopes: ['view'] }]),
        controller: () => import('./controllers/organization')
    },
    {
        path: [config.routes.organization.manageUsers],
        guard: getPermissionsGuard([{ resource: 'portal.organization', scopes: ['view', 'edit'] }]),
        controller: () => import('./controllers/manageUsers')
    },
    {
        path: [config.routes.organization.manageGroups],
        guard: getPermissionsGuard([{ resource: 'portal.organization', scopes: ['view', 'edit'] }]),
        controller: () => import('./controllers/manageGroups')
    }
];
